import { forwardRef, type Ref, type SVGProps } from "react";
const IconHDROutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 6.09H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1m-1 18H4v-16h24Z"
    />
    <path
      fill="currentColor"
      d="M7.36 16.71h2.72v2.91h1.45v-6.73h-1.45v2.64H7.36v-2.64H5.9v6.73h1.46zM18 18.73a3.24 3.24 0 0 0 1-2.54 3.16 3.16 0 0 0-1-2.43 3.67 3.67 0 0 0-2.61-.87h-2.12v6.73h1.94a4 4 0 0 0 2.79-.89m-3.27-4.67h.77c1.3 0 2 .72 2 2.16s-.71 2.22-2.11 2.22h-.62ZM21.85 17h.78l1.64 2.58h1.62c-.32-.44-1-1.42-2-2.93a2.25 2.25 0 0 0 .94-.73 1.78 1.78 0 0 0 .33-1.06 1.75 1.75 0 0 0-.67-1.51 3.43 3.43 0 0 0-2.07-.5h-2v6.73h1.45Zm0-3h.44a2.05 2.05 0 0 1 1.05.2.73.73 0 0 1 .33.68.8.8 0 0 1-.33.71 1.83 1.83 0 0 1-1 .23h-.47Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHDROutlineSVG);
ForwardRef.displayName = "IconHDROutline";
export { ForwardRef as IconHDROutline };
